<template>
    <div class="group-btn__wrapper">
        <div v-click-outside="closeList" @click="openList">
            <slot>
                <button type="button" ref="button" :class="{'settings-btn': !inAccordion, 'group-btn': inAccordion, 'accordion__action': inAccordion}">
                    <icon-base viewBox="0 0 4 12" :class="{'settings-btn__icon': !inAccordion, 'group-btn__icon': inAccordion}">
                        <icon-settings />
                    </icon-base>
                </button>
            </slot>
        </div>

        <ul v-if="open && !portal" class="group-btn__list" :class="{'group-btn__list_with0': toRight}">
            <li v-for="(option, index) in options" :key="index" class="group-btn__list-item" :class="{'group-btn__list-item_warning': option.warning}" @click.stop="emitToParent(index)">
                <span>{{ option.name }}</span>
            </li>
        </ul>
        
        <portal v-if="portal" :to="portal">
            <ul v-if="open" ref="list" class="group-btn__list group-btn__list_portal">
                    <li v-for="(option, index) in options" :key="index" class="group-btn__list-item" :class="{'group-btn__list-item_warning': option.warning}" @click.stop="emitToParent(index)">
                            <span>{{ option.name }}</span>
                    </li>
            </ul>
        </portal>
    </div>
</template>

<script>
export default {
    model: {
        prop: "value",
        event: "input",
    },
    props: {
        options: {
            type: Array,
            default: function() {
            return []
        },
        },
        params: {
            type: Object,
            default: function() {
                return {}
            }
        },
        inAccordion: {
            type: Boolean,
            default: false
        },
        clickStop: {
            type: Boolean,
            default: false
        },
        portal: {
            type: String,
            default: ''
        },
        toRight: {
            type: Boolean,
            default: false
        }
    },
    data: function() {
        return {
            open: false,
        }
    },
    methods: {
        emitToParent(index) {
            const emitObj = {
                callback: this.options[index].callback,
                args: this.params
            }
            this.$emit('clickOnItem', emitObj)
            this.closeList()
        },
        closeList() {
            this.open = false
        },
        openList(event) {
            this.inAccordion || this.clickStop ? event.stopPropagation() : null
            this.open = !this.open
        },
        setCoordinatesForList() {
            const button = this.$refs.button
            const coords = this.getCoords(button)

            this.$nextTick()
            .then(() => {
                let list = this.$refs.list

                if (!list) {
                    list = document.querySelector('.group-btn__list')
                }

                    list.style.top = `${coords.top + button.clientHeight + 8}px`
                    if (this.toRight) list.style.right = `${coords.right}px`
                    else list.style.left = `${coords.left}px`
                    list.style.display = 'block'
            })
        },
        getCoords(elem) {
            const box = elem.getBoundingClientRect()

            return {
                top: box.top + window.pageYOffset,
                left: box.left + window.pageXOffset,
                right: document.documentElement.clientWidth - box.right
            }
        }
    },
    watch: {
        open: function(newVal) {
        !!this.portal && newVal ? this.setCoordinatesForList() : null
        }
    }
}
</script>